import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var history = new Swiper(".section2 .swiper", {
    slidesPerView: 4.2,
    spaceBetween: 50,
    navigation: {
        nextEl: ".section2 .next",
        prevEl: ".section2 .prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4.2,
        spaceBetween: 50,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3.2,
        spaceBetween: 50,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        spaceBetween: 10,
      }
    } 
});

